import api from "./core";
const config = require("./serverCfg").default;
const basePath = "api/core/Statement";

export default {
  get(data, extraHeaders = null) {
    return api.patch(`${basePath}`, data, extraHeaders);
  },
  create(data, extraHeaders = null) {
    return api.post(`${basePath}`, data, extraHeaders);
  },
  statementViewUrl(statementId) {
    return {
      url: `${config.coreBaseUrl}${basePath}/RenderStatement/${statementId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    };
  }
};
